<template>
  <topbar position="fixed" type="primary" :transparent="transparent" :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto">
    <!--class="mobile-bg-primary"-->
    <template slot="navbar-menu">
      <!-- to show only in Mobile devices : IsWebView() && --->
      <div class="flex nav-left">
        <div class="pull-left">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item mobile icon ml-2 mr-2" v-if="IsWebView() && !isHome">
              <a class="nav-link" @click="goBack()" :disabled="isHome">
                <i class="new-ui-icons k-icon-left-open only-icon"></i>
              </a>
            </li>
            <li class="nav-item icon mobile" v-if="!isHome" :class="{ 'ml-2': !IsWebView() }">
              <router-link to="/" class="nav-link">
                <i class="new-ui-icons k-icon-home-outline only-icon"></i>
              </router-link>
            </li>
            <li v-if="isAuthenticated" class="nav-item icon mobile ml-2">
              <router-link to="/re-order" class="nav-link">
                <i class="now-ui-icons k-icon-re-order only-icon"></i>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <!-- to show only in desktop devices--->
      <div class="flex nav-right">
        <div class="pull-right">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item icon desktop" :style="[active == 'home' ? myTheme.topMenu.active : '']">
              <router-link to="/" class="nav-link">
                <i class="new-ui-icons k-icon-home-outline only-icon"></i>
                <p class="desktop">{{ $t("button.home") }}</p>
              </router-link>
            </li>
            <li v-if="isAuthenticated" class="nav-item icon desktop"
              :style="[active == 're-order' ? myTheme.topMenu.active : '']">
              <router-link to="/re-order" class="nav-link">
                <i class="now-ui-icons k-icon-re-order only-icon"></i>
                <p class="desktop">{{ $t("button.re_order") }}</p>
              </router-link>
            </li>
            <li class="nav-item desktop" v-if="!isLocationEmpty(selectedLocation)"
              :style="[active == 'contactus' ? myTheme.topMenu.active : '']">
              <router-link to="/contactus" class="nav-link">
                <i class="now-ui-icons k-icon-contactus only-icon"></i>
                <p>{{ $t("button.contact") }}</p>
              </router-link>
            </li>
            <li class="nav-item" v-if="!isAuthenticated">
              <div class="pull-right">
                <button v-if="getIsUKApp" class="nav-link btn btn-neutral login-min-width"
                  :style="myTheme.registrationButtons" @click="goToLogin()">
                  <i class="now-ui-icons k-icon-login"></i>
                  <p>{{ $t("button.login") }}</p>
                </button>
                <drop-down v-else title="Account">
                  <button slot="title" class="nav-link btn btn-neutral login-min-width" data-toggle="dropdown"
                    :style="myTheme.registrationButtons">
                    <p>
                      <img class="language-flag" :src="`/img/${$i18n.locale}.png`" />
                      {{ $t("button.account") }}
                    </p>
                  </button>
                  <a class="dropdown-item" @click.prevent="goToLogin()"><i class="now-ui-icons k-icon-login"></i>
                    {{ $t("button.login") }}</a>
                  <h6 class="dropdown-header">
                    {{ $t("text.select_language") }}
                  </h6>
                  <div v-for="(lang, index) in LOCALES" :key="index">
                    <a v-if="lang.code != $i18n.locale" @click.prevent="changeLanguage(lang.code)"
                      class="dropdown-item">
                      <img class="language-flag" :src="lang.flag" />{{
    $t(lang.name)
  }}</a>
                  </div>
                </drop-down>
              </div>
            </li>
            <li class="nav-item" v-else>
              <div class="pull-right">
                <button v-if="getIsUKApp" :style="myTheme.registrationButtons"
                  class="nav-link btn btn-neutral btn-account" @click="goToAccount()">
                  <i class="now-ui-icons users_circle-08 mr-1"></i>
                  <p>{{ $t("button.account") }}</p>
                </button>
                <drop-down v-else title="Account">
                  <button slot="title" class="nav-link btn btn-neutral btn-account" data-toggle="dropdown"
                    :style="myTheme.registrationButtons">
                    <p>
                      <img class="language-flag" :src="`/img/${$i18n.locale}.png`" />{{ $t("button.account") }}
                    </p>
                  </button>
                  <a class="dropdown-item" @click.prevent="goToAccount()"><i class="now-ui-icons k-icon-login"></i>
                    {{ $t("button.account") }}</a>
                  <h6 class="dropdown-header">
                    {{ $t("text.select_language") }}
                  </h6>
                  <div v-for="(lang, index) in LOCALES" :key="index">
                    <a v-if="lang.code != $i18n.locale" @click.prevent="changeLanguage(lang.code)"
                      class="dropdown-item">
                      <img class="language-flag" :src="lang.flag" />{{
    $t(lang.name)
  }}</a>
                  </div>
                </drop-down>
              </div>
            </li>
            <li class="nav-item" style="width: 100px">
              <button @click="startCheckoutProcess" class="nav-link btn btn-neutral" style="width: 100%"
                :style="{ color: myTheme.primaryTextColor }" :disabled="isLoading">
                <i class="mr-1" :class="isLoading ? 'k-icon-spin4 animate-spin' : 'new-ui-icons k-icon-basket-2'"></i>

                <p>{{ orderTotal | currency(currentCurrency) }}</p>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </template>
  </topbar>
</template>

<script>
import { Topbar, DropDown, Button } from "@/components";
import router from "../router";
import { mapState, mapGetters, mapActions } from "vuex";

import {
  IsWebView,
  canMakeOrder,
} from "@/utilities/helper";
import { LOCALES } from "@/utilities/enums";
import { couponMixin, orderingMixin } from "@/mixins";
export default {
  name: "main-navbar",
  mixins: [couponMixin, orderingMixin],
  props: {
    transparent: Boolean,
    colorOnScroll: Number,
  },
  components: {
    Topbar,
    DropDown,
    [Button.name]: Button,
  },
  data() {
    return {
      LOCALES,
      IsWebView,
    };
  },
  computed: {
    ...mapGetters('locationStore', ["getIsUKApp"]),
    ...mapState('cartStore', ['orderTotal']),
    active() {
      return this.$route.name;
    },
    locationStatus: function () {
      return canMakeOrder(this.selectedLocation, this.isMounted);
    },
    isHome() {
      return this.$route.name === "home";
    },
  },
  methods: {
    ...mapActions('locationStore', ["swicthLanguage"]),
    startCheckoutProcess() {
      if (this.active === 'cart') {
        return;
      }
      if (!this.selectedLocation) {
        this.showNotificationMessage(this.$t( "message.select_a_location"));
        return;
      }
      if (!this.locationStatus.can_make_order) {
        this.showNotificationMessage(this.$t( "text.not_taking_orders_right_now"))
        return;
      }
      if (!this.newCart || !this.newCart.order || !this.newCart.order.length) {
        this.showNotificationMessage(this.$t( "message.to_view_cart"))
        return;
      }
      this.checkoutOrder('cart')
    },
    goToLogin() {
      router.push("/login");
    },
    goToAccount() {
      if (this.isAuthenticated) {
        router.push("/account").catch();
      } else {
        router.push("/login");
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    changeLanguage(code) {
      this.$i18n.locale = code;
      this.swicthLanguage(code);
    },
    goToHome() {
      if (this.$route.name != "home") {
        router.push("/");
      }
    },
    showNotificationMessage(message) {
      const confirmOptions = {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "OK",
        customClass: "wtf-confirm",
        confirmButtonClass: "w-50 py-3 el-button--danger",
        showClose: false,
        center: true,
        closeOnClickModal: false,
        type: "danger"
      }

      this.$alert(message, 
      'Warning',
        confirmOptions
      ).then(() => {
      })
    }
  },
};
</script>
<style>
.language-flag {
  max-width: 20px;
  padding-right: 5px;
}

.navbar-nav {
  width: 100%;
}

.nav-left {
  width: 39%;
}

.nav-right {
  width: 59%;
}

.btn-account {
  min-width: 95px;
}

.login-min-width {
  min-width: 116px;
}
</style>
